import VerticalBookingCardBase from '../common/VerticalBookingCardBase';

function BookingCardBash({ booking, updateBookingState }) {
  return (
    <VerticalBookingCardBase
      booking={booking}
      color='#ffffff'
      showProductInfo={true}
      showVariationInfo={true}
    />
  );
}

export default BookingCardBash;
